import React, { Component} from "react";

class Pantalla15 extends Component {
    render() {
        return (
            <div id="pantalla15" className="contenedorgrafica">
                contenedor 15
            </div>
        );
    }
}
export default Pantalla15;